export default "__VITE_ASSET__CJOUQyAm__"